import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import TypeaheadPattern from '@mlb/react-patterns/components/TypeAhead/typeAhead.tsx';
import { styledListWrapper } from '@mlb/react-patterns/components/TypeAhead/typeAhead.style';
import { styledIcons } from '@mlb/react-patterns/components/TextInput/textInput.style';
import LinkPattern from '@mlb/react-patterns/components/Link/link.tsx';

export const ListItemTextContainer = styled.div`
  margin: 0px 10px;
  color: ${COLORS.mlbWhite};
  font-size: 15px;
  font-weight: 600;
`;

export const ListItemTeamAttrContainer = styled.span`
  color: ${COLORS.mlbGrey4};
  margin-left: 5px;
`;

export const Typeahead = styled(TypeaheadPattern)`
  svg {
    display: block;
  }
  ${styledListWrapper} {
    border: 0;
    border-radius: 5px;
  }
  ${styledIcons} {
    svg {
      opacity: ${({ additionalProps }) => additionalProps?.disabled ? '0.3' : '1'};
    }
  }
`;

export const Link = styled(LinkPattern)`
  display: flex;
  align-items: center;
  line-height: 0;
`;

export const PlaceholderContainer = styled.div`
  display: table;
  width: 100%;
  background: ${COLORS.mlbGrey7};
  button {
    display: block;
    margin: 20px auto;
  }
`;
